/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EnergyCharacteristics } from "./EnergyCharacteristics";
import {
  EnergyCharacteristicsFromJSON,
  EnergyCharacteristicsFromJSONTyped,
  EnergyCharacteristicsToJSON,
  EnergyCharacteristicsToJSONTyped,
} from "./EnergyCharacteristics";

/**
 *
 * @export
 * @interface ApiGufEnergycharacteristicsList200Response
 */
export interface ApiGufEnergycharacteristicsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGufEnergycharacteristicsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGufEnergycharacteristicsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGufEnergycharacteristicsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<EnergyCharacteristics>}
   * @memberof ApiGufEnergycharacteristicsList200Response
   */
  results: Array<EnergyCharacteristics>;
}

/**
 * Check if a given object implements the ApiGufEnergycharacteristicsList200Response interface.
 */
export function instanceOfApiGufEnergycharacteristicsList200Response(
  value: object
): value is ApiGufEnergycharacteristicsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGufEnergycharacteristicsList200ResponseFromJSON(
  json: any
): ApiGufEnergycharacteristicsList200Response {
  return ApiGufEnergycharacteristicsList200ResponseFromJSONTyped(json, false);
}

export function ApiGufEnergycharacteristicsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGufEnergycharacteristicsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(EnergyCharacteristicsFromJSON),
  };
}

export function ApiGufEnergycharacteristicsList200ResponseToJSON(
  json: any
): ApiGufEnergycharacteristicsList200Response {
  return ApiGufEnergycharacteristicsList200ResponseToJSONTyped(json, false);
}

export function ApiGufEnergycharacteristicsList200ResponseToJSONTyped(
  value?: ApiGufEnergycharacteristicsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(EnergyCharacteristicsToJSON),
  };
}
